import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { ErrorBoundary } from "./ErrorBoundary";

const NAV: { to: string; label: string }[] = [
  { to: "/quizzes", label: "Quizzes" },
  { to: "/analytics", label: "Analytics" },
];

export function Layout() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-mars-black text-mars-white">
      <header className="border-b border-mars-line bg-mars-night">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-6 px-6 py-4">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-3">
              <img
                src="/images/mars-men-logo-white.png"
                alt="Mars Men"
                className="h-5 w-auto"
              />
              <span className="heading text-[0.7rem] text-mars-orange">Quiz Admin</span>
            </div>
            <nav className="flex gap-1">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `mono rounded-md px-3 py-1.5 text-[0.7rem] uppercase tracking-[0.16em] transition-colors ${
                      isActive
                        ? "bg-mars-orange text-mars-black"
                        : "text-mars-white/70 hover:bg-mars-charcoal hover:text-mars-white"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <button
            type="button"
            onClick={async () => {
              await logout();
              nav("/login");
            }}
            className="mono rounded-md border border-mars-line px-3 py-1.5 text-[0.65rem] uppercase tracking-[0.18em] text-mars-white/70 transition-colors hover:border-mars-orange hover:text-mars-white"
          >
            Log out
          </button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl px-6 py-10">
        {/* Wraps the ROUTED page, not the chrome, so a page crash leaves the
            nav and Log out reachable -- the difference between "one screen is
            broken" and "the admin is down". Keyed on pathname so navigating
            away and back clears a latched error without a reload. */}
        <ErrorBoundary label="This page" resetKey={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
